module.exports = __webpack_public_path__ + "img/support_ticket.d4561410.svg";